import { createAction, props } from '@ngrx/store';
import { UserResource } from '../user.model';
import { UserProfile, UserProfileResource } from './userprofile.model';

const PREFIX = '[User Profile] ';

export const loadUserProfileAction = createAction(
	PREFIX + 'Load User Profile',
	props<{
		user: UserResource;
	}>()
);

export const loadUserProfileSuccessAction = createAction(
	PREFIX + 'Load User Profile Success',
	props<{
		userProfile: UserProfileResource;
	}>()
);

export const updateUserProfileAction = createAction(
	PREFIX + 'Update User Profile',
	props<{
		userProfile: UserProfile;
	}>()
);

export const updateUserProfileSuccessAction = createAction(
	PREFIX + 'Update User Profile Success',
	props<{
		userProfile: UserProfileResource;
	}>()
);
